<template>
  <el-row type="flex" justify="center" v-if="$route.name === 'Proscan'">
    <el-col v-if="params.data.status === 'FAILED'">
      <b-icon icon="exclamation-triangle" class="bicon" v-show="params.data.info"></b-icon> {{ params.data.info }}
    </el-col>
    <el-col v-else>
      {{ params.data.info }}
    </el-col>
  </el-row>
</template>
<script>
import Vue from 'vue'
import { BIcon, BIconExclamationTriangle } from 'bootstrap-vue'
export default Vue.extend({
  components: { BIcon, BIconExclamationTriangle }
})
</script>


// WEBPACK FOOTER //
// src/components/SigmaClientNew/AgGridIconRender.vue